var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedrockStableLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "213px",
    viewBox: "0 0 256 213",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stability AI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D39FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A380FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.418311,212.449785 C121.895828,212.449785 154.076327,186.244638 154.076327,146.823527 C154.076327,116.252053 134.503517,96.8259255 99.5072246,88.7808007 L77.0381637,82.0413304 C57.327608,77.6165118 45.8227858,72.3031898 48.5334508,58.7294108 C50.7884827,47.4372353 57.5348302,41.0624336 73.2228235,41.0624336 C123.095165,41.0624336 141.57308,58.7294108 141.57308,58.7294108 L141.57308,16.2373709 C141.57308,16.2373709 123.58314,0 73.2228235,0 C25.7565874,0 2.1513352e-14,24.4237956 2.1513352e-14,62.235882 C2.1513352e-14,92.8073562 17.8493354,110.58622 54.0523968,119.033601 C56.5861391,119.667138 57.8811457,119.992613 57.9374165,120.010028 C63.4441876,121.714275 70.87496,123.966007 80.2297338,126.765222 C98.7335207,131.190041 103.491968,135.886327 103.491968,149.965296 C103.491968,162.837495 90.1175855,170.154389 72.418311,170.154389 C21.4319569,170.154389 2.1513352e-14,144.361226 2.1513352e-14,144.361226 L2.1513352e-14,191.438959 C2.1513352e-14,191.438959 13.4024656,212.449785 72.418311,212.449785 Z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.442113,209.266419 C242.957,209.266419 256,196.596076 256,179.453847 C256,161.938961 243.329657,149.641275 225.442113,149.641275 C207.927227,149.641275 195.256884,161.938961 195.256884,179.453847 C195.256884,196.968733 207.927227,209.266419 225.442113,209.266419 Z",
    fill: "#E80000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedrockStableLogo);
export default __webpack_public_path__ + "static/media/bedrock-stable-logo.f33d971653e2381e6eaab94949f47ce1.svg";
export { ForwardRef as ReactComponent };